import SocialShareType from '@/utils/SocialShareType';

export default class SocialPlatformsService {
  public static getShareLink(
      emailSubject: string,
      emailBody: string,
      socialShareType: SocialShareType,
      urlToShare: string,
      title: string,
      sourceUrl?: string): string {

    const urlToShareEnc = encodeURIComponent(urlToShare);
    const sourceUrlEnc = sourceUrl ? encodeURIComponent(sourceUrl) : undefined;
    const titleEnc = encodeURIComponent(title);

    switch(socialShareType) {
      case SocialShareType.FB:
        return `http://www.facebook.com/sharer/sharer.php?u=${urlToShareEnc}title=${titleEnc}`;
      case SocialShareType.TW:
        return `http://twitter.com/intent/tweet?status=${urlToShareEnc}`;
      case SocialShareType.LD:
        return `http://www.linkedin.com/shareArticle?mini=true&url=${urlToShareEnc}&title=${titleEnc}${sourceUrlEnc ? '&source=' + sourceUrlEnc : ''}`;
      case SocialShareType.MAIL:
        return `mailto:?subject=${emailSubject}&body=${emailBody} ${urlToShare}`;
      case SocialShareType.WECHAT:
        return `http://api.addthis.com/oexchange/0.8/forward/wechat/offer?url=${urlToShareEnc}&title=${titleEnc}`;
      case SocialShareType.WEIBO:
        return `http://service.weibo.com/share/share.php?url=${urlToShareEnc}&title=${titleEnc}`;
    }
  }

  public static getDataTarget(socialShareType: SocialShareType) {
    switch(socialShareType) {
      case SocialShareType.FB:
        return 'facebook';
      case SocialShareType.TW:
        return 'twitter';
      case SocialShareType.LD:
        return 'linkedin';
      case SocialShareType.MAIL:
        return 'email';
      case SocialShareType.WECHAT:
        return 'wechat';
      case SocialShareType.WEIBO:
        return 'weibo';
    }
  }
  

  public static isSupported(socialShareType: SocialShareType, countryCode?: string): boolean {
    switch(socialShareType) {
      case SocialShareType.FB:
      case SocialShareType.TW:
        if(countryCode && countryCode === 'cn') {
          return false;
        }
      case SocialShareType.LD:
      case SocialShareType.MAIL:
        return true;
      case SocialShareType.WECHAT:
      case SocialShareType.WEIBO:
        if(countryCode && countryCode !== 'cn' && countryCode !== 'hk') {
          return false;
        }
      default:
        return true;
    }
  }

}